import {SELECT_VIEW} from './settings/constants';
import {selectViewFunction} from '../../moduls/utils';
import AbstractPage from './view/abstract-page';

export default class Page extends AbstractPage  {
  constructor(props) {
    super(props);
  }

  render() {
    const Page = selectViewFunction(this.screenData, SELECT_VIEW);
    return <Page {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./components/page/index.js